const PlayersData = {
    players: [
        {
            id: 1,
            name: "MS Dhoni",
            country: "India",
            age: "41y 308d",
            image: "https://www.starpng.com/public/uploads/preview/mahendra-singh-dhoni-indian-cricketer-21564039669ufgukfomsf.png",
            role: "Wicketkeeper Batsman",
            battingStyle: "Right Handed Bat",
            bowlingStyle: "Right-arm medium",
            matches: 98,
            innings: 85,
            notOuts: 42,
            runs: 4632,
            highestScore: 56,
            ballsFaced: 1282,
            strikeRate: 126.13,
            average: 37.60,
        },
        {
            id: 2,
            name: "Virat Kohli",
            country: "India",
            age: "34y 187d",
            image: "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/bcci/1000x1280/164.png",
            role: "Batsman",
            battingStyle: "Right Handed Bat",
            bowlingStyle: "Right-arm medium",
            matches: 115,
            innings: 107,
            notOuts: 31,
            runs: 4008,
            highestScore: 122,
            ballsFaced: 2905,
            strikeRate: 137.96,
            average: 52.73,
        },
        {
            id: 3,
            name: "Rohit Sharma",
            country: "India",
            age: "36y 11d",
            image: "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/bcci/1000x1280/107.png",
            role: "Batsman",
            battingStyle: "Right Handed Bat",
            bowlingStyle: "Right-arm offbreak",
            matches: 148,
            innings: 140,
            notOuts: 17,
            runs: 3853,
            highestScore: 118,
            ballsFaced: 2767,
            strikeRate: 139.24,
            average: 31.32,
        },
        {
            id: 4,
            name: "KL Rahul",
            country: "India",
            age: "31y 23d",
            image: "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/bcci/1000x1280/164.png",
            role: "Wicketkeeper Batsman",
            battingStyle: "Right Handed Bat",
            bowlingStyle: "Right-arm medium",
            matches: 72,
            innings: 68,
            notOuts: 8,
            runs: 2265,
            highestScore: 110,
            ballsFaced: 1628,
            strikeRate: 139.12,
            average: 37.75,
        },
        {
            id: 5,
            name: "Shubnam Gill",
            country: "India",
            age: "23y 245d",
            image: "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/bcci/1000x1280/3761.png",
            role: "Batsman",
            battingStyle: "Right Handed Bat",
            bowlingStyle: "Right-arm offbreak",
            matches: 6,
            innings: 6,
            notOuts: 1,
            runs: 202,
            highestScore: 76,
            ballsFaced: 165,
            strikeRate: 122.42,
            average: 40.40,
        },
        {
            id: 6,
            name: "Suryakumar Yadav",
            country: "India",
            age: "32y 239d",
            image: "https://www.mumbaiindians.com/static-assets/images/players/large/11803.png?v=2.13&w=400",
            role: "Batsman",
            battingStyle: "Right Handed Bat",
            bowlingStyle: "Right-arm medium",
            matches: 48,
            innings: 46,
            notOuts: 10,
            runs: 1675,
            highestScore: 117,
            ballsFaced: 953,
            strikeRate: 175.76,
            average: 46.52,
        },
        {
            id: 7,
            name: "Rishabh Pant",
            country: "India",
            age: "25y 219d",
            image: "https://1459212308.rsc.cdn77.org/1651146480rishabh_pant.png",
            role: "Wicketkeeper Batsman",
            battingStyle: "Left Handed Bat",
            bowlingStyle: "Right-arm medium",
            matches: 66,
            innings: 56,
            notOuts: 12,
            runs: 987,
            highestScore: 65,
            ballsFaced: 781,
            strikeRate: 126.37,
            average: 22.43,
        },
    ],

    getPlayers() {
        return this.players;
    },

    getPlayer(id) {
        return this.players.find((player) => player.id === id);
    },
};

export default PlayersData;